/**
 * Normalize CV text_boxes into the flat shape the overlay expects:
 * { left, top, width, height, text, score, bg_hex, quad }.
 *
 * CV PR 16 shape: { bbox:{left,top,width,height}, quad, text, score, bg_hex }
 * Legacy shape may already be flat.
 */

/**
 * @param {Object|null|undefined} box
 * @returns {Object|null}
 */
export function normalizeTextBox(box) {
  if (!box || typeof box !== "object") return null;

  const bbox = box.bbox && typeof box.bbox === "object" ? box.bbox : null;
  const left = Number(bbox?.left ?? box.left);
  const top = Number(bbox?.top ?? box.top);
  const width = Number(bbox?.width ?? box.width);
  const height = Number(bbox?.height ?? box.height);

  if (![left, top, width, height].every(Number.isFinite)) {
    return null;
  }
  // Degenerate / inverted boxes are useless for covers and can confuse SVG.
  if (!(width > 0) || !(height > 0)) {
    return null;
  }

  const normalized = {
    left,
    top,
    width,
    height,
  };

  if (box.text != null) normalized.text = box.text;
  if (box.score != null) normalized.score = box.score;
  if (box.bg_hex != null) normalized.bg_hex = box.bg_hex;
  if (box.quad != null) normalized.quad = box.quad;

  return normalized;
}

/**
 * @param {Array|null|undefined} boxes
 * @returns {Array}
 */
export function normalizeTextBoxes(boxes) {
  if (!Array.isArray(boxes) || boxes.length === 0) return [];

  return boxes.map(normalizeTextBox).filter(Boolean);
}
